import React,{useState,useEffect} from 'react';
import PropTypes from 'prop-types';
import { withStyles,makeStyles, useTheme } from '@material-ui/core/styles';

import FirstPageIcon from '@material-ui/icons/FirstPage';
import KeyboardArrowLeft from '@material-ui/icons/KeyboardArrowLeft';
import KeyboardArrowRight from '@material-ui/icons/KeyboardArrowRight';
import {LastPage,AllInclusive,Add,MoreVert,Schedule,Block,Edit,Delete,Place, FormatAlignCenter} from '@material-ui/icons';


import {
  TableRow ,
  TablePagination,
  TableFooter,
  TableContainer,
  TableCell,
  TableBody,
  Table ,
  TableHead,
  Button,
  IconButton,
  Paper,
  Typography,
  Toolbar,
  Box,
  Dialog,
  DialogActions,
  DialogContent,
  DialogContentText,
  DialogTitle,
  AppBar,
  TextField,
  FormControlLabel,
  Checkbox,
  Container ,
  FormControl,
  InputLabel,
  MenuItem,
  Select,
  Menu,
  TextareaAutosize,
  LinearProgress,
  FormHelperText,
  CircularProgress
} from "@material-ui/core";

import { withLocalize,Translate } from "react-localize-redux";
import MUIDataTable from "mui-datatables";
import API from './api';

import { useSnackbar } from 'notistack';
import { setDayWithOptions } from 'date-fns/fp';

// import * as userInfo from "./login_info.js";

import UserInfo from "./login_info";

import axios from 'axios';

import Format from "date-fns/format";

import {FinanceService, TransportService} from "./../../utils/web_config_2";


const useStyles1 = makeStyles((theme) => ({
  root: {
    flexShrink: 0,
    flexFlow:1,
    [theme.breakpoints.up('sm')]:{
      marginLeft:250,
    }
  },
  btn:{
    textTransform:"capitalize",

  },
  formTitle:{
    flexGrow:1,
}
}));




function Initiate_settlement() {
  const classes = useStyles1();
  const { enqueueSnackbar, closeSnackbar } = useSnackbar();


  const [operatorData, setOperatorData] = useState({});

  const [settlementMessage,setSettlementMessage]=useState("No Settlement proccesses available...");


  // process table 


const columns = [
  {
    name: "process_reference",
    label: "Process Reference",
    options: {
      display:false,
     filter: true,
     sort: true,
    }
   },
  {
   name: "settlement_date",
   label: "Settlement Date",
   options: {
    filter: true,
    sort: false,
   }
  },
  {
    name: "trx_count",
    label: "Trx Count",
    options: {
     filter: true,
     sort: false,
    }
   },
   {
    name: "batch_count",
    label: "Batch Count",
    options: {
     filter: true,
     sort: false,
    }
   },
  {
   name: "start_time",
   label: "Start Time",
   options: {
    filter: true,
    sort: false,
    customBodyRender: (value, tableMeta, updateValue) => {
        return (<Typography >
          {value}
        </Typography>
        );
     }
   }
  }, {
    name: "end_time",
    label: "End Time",
    options: {
     filter: true,
     sort: true,  
     customBodyRender: (value, tableMeta, updateValue) => {
        return (<Typography >
          {value}
        </Typography>
        );
     }
    }
   },
   {
    name: "status",
    label: "Status",
    options: {
     filter: true,
     sort: true,
    }
   }
 ];


 const options = {
  textLabels: {
    body: {
      noMatch: settlementMessage
    },
  },
   filterType: 'checkbox',
   download:true,
   responsive:"standard",
   selectableRows:false,
   rowsPerPage: 10,
   elevation:0,
 };



  // new settlement dialog 

  const [open, setOpen] = useState(false);

  const handleClickOpen = () => {
    setOpen(true);
  };

  const handleClose = () => {
    setOpen(false);
  };

  useEffect(()=>{

    var data = {};
    const data1 = localStorage.getItem("nx_op");
    if (data1 != null) {
      data = JSON.parse(data1);
    }

    setOperatorData(data);
    axios.defaults.baseURL = new TransportService().BASE_URL;

    getSettlementProcess(data.token);

  },[]);




  // get settlement processes
  const [settlementLoad,setSettlementLoad]=useState(false);
  const [settlementProcess,setSettlementProcess]=useState()
const getSettlementProcess=(token)=>{
    setSettlementLoad(true);
  const provinceInstance = axios.create(new FinanceService().setHeaders(token));
  provinceInstance.get(new FinanceService().INITIATE_SETTLEMENT)
  .then(res=>{
 var objs=res.data.data;
 console.log("objs",objs);
 if(objs.length==0){
    setSettlementMessage("No settlement process available");
 }
 setSettlementProcess(objs);
 setSettlementLoad(false);
})
.catch(err=>{
    setSettlementLoad(false);
});
}



// new settlement process 



const [processLoad,setProcessLoad]=useState(false);

const new_settlement_process=()=>{
    const data={
        "settlement_date":Format(new Date(), ["yyyy-MM-dd",])
      };

    setProcessLoad(true);
    const provinceInstance = axios.create(new FinanceService().setHeaders(operatorData.token));
    provinceInstance.post(new FinanceService().INITIATE_NEW_SETTLEMENT,data)
    .then(res=>{
        handleClose();
        setProcessLoad(false);
        enqueueSnackbar('Settlement process initiated successful',
          { 
            variant: 'success'
        });
    })
    .catch(err=>{
        setProcessLoad(false);
    });
}


  return (
    <div className={classes.root}>
      <Box display="flex">
 
 <Box display="flex" alignItems="center" mt={2} className={classes.formTitle}>
 
 <Box mr={1}><Place fontSize="large" color="primary"/></Box> <Typography  variant="h5" color="default"><b>Settlement Processes</b></Typography>

 </Box>
 
 
<Button  
className={classes.btn}
size="small"
startIcon={<Add/>} 
onClick={()=>{handleClickOpen()}} 
variant="contained" 
color="primary"
disableElevation={true}>

<Typography noWrap>Initiate settlement</Typography>
</Button>
 
     </Box>

 {/* stops table  */}

 <Box mt={2}>
 {settlementLoad&&<LinearProgress />}
 <MUIDataTable
  title={"Settlement Process"}
  data={settlementProcess}
  columns={columns}
  options={options}
/>
 </Box> 


{/* new initiate settlement process */}




 <Dialog
    maxWidth="sm"
    fullWidth
        open={open}
        onClose={()=>{
            handleClose();
        }}
        aria-labelledby="settlement_process"
        aria-describedby="settlement_process"
      >
        <DialogTitle id="settlement_process">{"New settlement process"}</DialogTitle>
        <DialogContent>
          <DialogContentText >
          <Box>
             
          <Box display='flex' alignItems='center' justifyContent='center'>
            <Typography>Are you sure you want to initiate new settlement process</Typography>
            </Box>
            
        </Box>
          </DialogContentText>
        </DialogContent>
        <DialogActions>
          
          <Button onClick={()=>{
            handleClose();
          }} color="secondary" variant="outlined" >
           No
          </Button>
          <Button disableElevation onClick={()=>{
new_settlement_process();
          }} variant="contained" color="primary" autoFocus>
             {processLoad?<CircularProgress color="secondary" size={25}/>:"Yes"}
              </Button>
        </DialogActions>
      </Dialog>



    </div>
  );
}

export default  withLocalize(Initiate_settlement);